import { Sprite, Texture, Text, BitmapText } from 'pixi.js';
import Button from './Button';
// import PressButton from "./PressButton"
// import ToggleButton from "./ToggleButton"

class SwitchButton extends Button {
	constructor(obj) {
		super(obj);
		this.active = obj.active;

		if (obj.bg2) {
			this.bg2 = Sprite.from(Texture.from(obj.bg2));
			this.addChild(this.bg2);
		}
		if (obj.bg) {
			this.bg = Sprite.from(Texture.from(obj.bg));
			this.addChild(this.bg);
			if (obj.bgimg) {
				this.bgimg = Sprite.from(Texture.from(obj.bgimg));
				this.bgimg.anchor.set(0.5, 0.5);
				this.bgimg.position.set(this.bg.width / 2, this.bg.height / 2);
				this.bg.addChild(this.bgimg);
			}
			if (obj.bgText) {
				if (obj.custom) {
					this.bgText = new BitmapText(
						window.lm[obj.bgText].value,
						window.lm[obj.bgText].config
					);
					this.bgText.name = obj.name;
					if (obj.anchor) {
						this.bgText.anchor.x = obj.anchor.x;
						this.bgText.anchor.y = obj.anchor.y;
					}
					this.bgText.position.set(
						this.bg.width / 2 + 7,
						this.bg.height / 2 + 5
					);
					this.addChild(this.bgText);
				} else {
					this.bgText = new Text(
						window.lm[obj.bgText].value,
						window.lm[obj.bgText].config
					);
					this.bgText.anchor.set(0.5, 0.5);
					this.bgText.position.set(this.bg.width / 2, this.bg.height / 2);
					this.bg.addChild(this.bgText);
				}
			}
		}

		if (obj.text) {
			this.text = new Text(
				window.lm[obj.text].value,
				window.lm[obj.text].config
			);
			// this.text.anchor.set(0.5, 0.5)
			// this.text.position.set(this.fg.width / 2, this.fg.height / 2)
			this.addChild(this.text);
		}
		if (obj.fg) {
			this.fg = Sprite.from(Texture.from(obj.fg));
			this.addChild(this.fg);

			if (obj.fgimg) {
				this.fgimg = Sprite.from(Texture.from(obj.fgimg));
				this.fgimg.anchor.set(0.5, 0.5);
				this.fgimg.position.set(this.fg.width / 2, this.fg.height / 2);
				this.fg.addChild(this.fgimg);
			}
			if (obj.fgText) {
				if (obj.custom) {
					this.fgText = new BitmapText(
						window.lm[obj.fgText].value,
						window.lm[obj.fgText].config
					);
					this.fgText.name = obj.name;
					if (obj.anchor) {
						this.fgText.anchor.x = obj.anchor.x;
						this.fgText.anchor.y = obj.anchor.y;
					}
					this.fgText.position.set(
						this.fg.width / 2 + 7,
						this.fg.height / 2 + 5
					);
					this.addChild(this.fgText);
				} else {
					this.fgText = new Text(
						window.lm[obj.fgText].value,
						window.lm[obj.fgText].config
					);
					this.fgText.anchor.set(0.5, 0.5);
					this.fgText.position.set(this.fg.width / 2, this.fg.height / 2);
					this.fg.addChild(this.fgText);
				}
			}
		}
	}
	setActive(active) {
		this.active = active;

		// if (this.active) {
		//   this.fg.alpha = 0
		//   this.bg.alpha = 1
		// } else {
		//   this.fg.alpha = 1
		//   this.bg.alpha = 0
		// }
	}

	clickHandler(e) {
		super.clickHandler(e);
		// if(this.active){
		//   window.sm.play({ name: "double_chance_on_sfx" });
		//  }else{
		//   window.sm.play({ name: "double_chance_off_sfx" });
		//  }
		// this.active = !this.active
		// if (this.active) {
		//   this.fg.alpha = 0
		//   this.bg.alpha = 1
		// } else {
		//   this.fg.alpha = 1
		//   this.bg.alpha = 0
		// }
	}
	mouseDownHandler(e) {}

	mouseUpHandler(e) {}

	getSize() {
		return {
			width: this.bg.width,
			height: this.bg.height
		};
	}
}

export default SwitchButton;
